import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import {
  CreditCardPrintPdfDetailRequest,
  CreditCardTransactionsRequest,
  CreditCardTransactionsResponse,
  PkInvoiceUploadRequest,
  PkInvoiceUploadResponse,
  PkPendingInvoice,
  SendCreditCardCancellationEmailRequest,
} from './creditCardOperationsModel'

export class creditCardOperationsService extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'dealerInformation/creditCardTransactions',
      requesterInfo,
    })
  }

  // Yalnızca ödeme (payment) hareketlerini getirir. Sepet için basketOperationsService kullanılır.
  public async creditCardTransactions(req: CreditCardTransactionsRequest): Promise<CreditCardTransactionsResponse[]> {
    return await this.postAsync<CreditCardTransactionsResponse[]>(req)
  }

  public async sendCreditCardCancellationEmail(req: SendCreditCardCancellationEmailRequest): Promise<boolean> {
    this.props.url = 'dealerInformation/sendCreditCardCancellationEmail'
    return await this.postAsync<boolean>(req)
  }

  // Peşine Kontrat IMEI faturası yükler (yeni yükleme ya da değiştirme). Bayi kodu sunucuda oturumdan alınır.
  public async uploadPkInvoice(req: PkInvoiceUploadRequest): Promise<PkInvoiceUploadResponse> {
    this.props.url = 'dealerInformation/pkInvoice/upload'
    return await this.postAsync<PkInvoiceUploadResponse>(req)
  }

  // Faturası beklenen Peşine Kontrat IMEI'leri; yalnız oturumdaki bayinin, tarih filtresinden bağımsız.
  public async listPendingPkInvoices(): Promise<PkPendingInvoice[]> {
    this.props.url = 'dealerInformation/pkInvoice/pending'
    return await this.getAsync<PkPendingInvoice[]>()
  }

  public async creditCardPrintPdfDetail(req: CreditCardPrintPdfDetailRequest): Promise<string> {
    this.props.url = 'dealerInformation/creditCardPrintPdfDetail'
    return await this.postAsync<string>(req)
  }

  public async creditCardPrintPdfDetailIyzico(req: CreditCardPrintPdfDetailRequest): Promise<string> {
    this.props.url = 'dealerInformation/creditCardPrintPdfDetailIyzico'
    return await this.postAsync<string>(req)
  }
}
